import curd from '../curd'

const BASE_PATH = '/running/condition'

export default curd(BASE_PATH, {
  getList: query => ({
    url: `${BASE_PATH}/list`,
    method: 'POST',
    data: query
  }),
  submit: query => ({
    url: `${BASE_PATH}/submit`,
    method: 'PUT',
    data: query
  }),
  return: query => ({
    url: `${BASE_PATH}/back`,
    method: 'PUT',
    data: query
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/Operations.js